import React, { Component } from 'react';
import './notification.scss';
import { Tooltip } from "reactstrap";
import { Constants, ImageConstants } from '../../../constants/constants';
import Utils from '../../../utility/common-utilities';
// import HomeworkApi from '../../../../apis/homework'
import { getImageSource } from '../../../utility/image-source'
import moment from 'moment';
import Dropdown from '../../common/dropdown-v2/dropdown';
import CommonApi from '../../../apis/common'
import SessionCache from '../../routes/session-cache';
import ReactTooltip from 'react-tooltip';
import SchoolApi from '../../../apis/school';
import CommonUtils from '../../../utility/common-utilities';
import VideoSchoolAssignmentApi from '../../../apis/video-school-assignment';
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';

class Reminder extends Component {

    state = {
        message: this.props.message,
        emails: [""],
        whatsapp: [{ countryCode: "+91" }],
        sms: [{ countryCode: "+91" }],
        type: this.props.type,
        countryCodeDropdown: [],
        invalidSms: {},
        invalidEmails: [],
        invalidWhatsapp: {},
        sections: [],
        classes: [],
        selectedClasses: [{ class: "", sections: [] }],
        board: "",
        boards: [],
        selectedClass: "",
        whatsappVideoAssignmentType: "",
        videoLink: ''
    }
    notificationText = "An assignment has been created for you. You must complete this assignment on the Countingwell App. To view and complete the assignment, open this link on your mobile phone: "
    notificationLink = Constants.SCHOOL_ASSESSMENT_DEEPLINK
    countryCodeHash = {}
    dropdown = []

    constructor(props) {
        super(props)
        this.state.classes = this.props.classes
        this.state.boards = this.props.boards
        this.state.board = this.state.boards?.length ? this.state.boards[0].value : ""
        this.state.selectedEloVideoDetails = this.props.selectedEloVideoDetails ? this.props.selectedEloVideoDetails : null
        this.state.contentId = this.props.contentId
    }

    componentDidMount() {
        this.getCountryCodes()

        this.userInfo = SessionCache.getUser()

        let whatsapp = this.state.whatsapp



        if (this.userInfo.mobileNumber) {
            console.log('....inside')
            whatsapp.forEach(item => {
                item.countryCode = this.userInfo.countryCode
                item.mobileNumber = this.userInfo.mobileNumber
            })

            this.setState({ whatsapp, whatsappVideoAssignmentType: '' })

            this.createTeacherVideoSchoolAssignment('MOBILE_NUMBER')

        } else {
            let whatsapp = this.state.whatsapp
             whatsapp.forEach(item => {
                // item.countryCode = this.userInfo.countryCode
                item.mobileNumber = "9731201212"
            })

            this.setState({ whatsapp, whatsappVideoAssignmentType: '' })

            this.createTeacherVideoSchoolAssignment('MOBILE_NUMBER')
        }

    }


    createTeacherVideoSchoolAssignment(toasterType) {
        let eloDetail = this.state.selectedEloVideoDetails

        console.log(eloDetail, this.state.whatsappVideoAssignmentType)

        this.setState({ errorMessage: '' })



        if (!this.validatePayloadForMobileNumber()) return false

        // let payload = {
        //     chapterKey: eloDetail ? eloDetail?.chapterKey ? eloDetail?.chapterKey : this.props.chapterKey : this.props.chapterKey,
        //     chapterTitle: eloDetail ? eloDetail?.chapterTitle ? eloDetail?.chapterTitle : this.props.chapterTitle : this.props.chapterTitle,
        //     conceptKey: eloDetail ? eloDetail?.conceptKey : this.props.conceptKey ? this.props.conceptKey : null,
        //     conceptTitle: eloDetail ? eloDetail?.conceptTitle ? eloDetail?.conceptTitle : this.props.conceptTitle : this.props.conceptTitle ? this.props.conceptTitle : null,
        //     eloId: eloDetail.eloId ? eloDetail.eloId : eloDetail.elos[0].id ? eloDetail.elos[0].id : null,
        //     eloTitle: eloDetail ? eloDetail.elos[0].title ? eloDetail.elos[0].title : eloDetail.title : this.props.contentDisplayTitle ? this.props.contentDisplayTitle : "Chapter Introduction Video",
        //     videoContentIds: this.state.contentId,
        //     mobileNumbers: this.state.whatsapp,
        //     subType: 'USING_MOBILE_NUMBER',
        //     type: 'TEACHER_RESOURCE_VIDEO'
        // }


        let payload = {
        }

        if (this.props.contentFrom === 'ELO_LIST' || this.props.contentFrom === "CHAPTER_PK") {
            payload = {
                // board: this.props.selectedBoard,
                // class: this.props.selectedClass,
                // section: this.state.sectionName,
                // boardClassSections: this.state.selectedClasses,
                // sectionId: sectionsPayload.sections,
                chapterKey: eloDetail ? eloDetail?.chapterKey ? eloDetail?.chapterKey : this.props.chapterKey : this.props.chapterKey,
                chapterTitle: eloDetail ? eloDetail?.chapterTitle ? eloDetail?.chapterTitle : this.props.chapterTitle : this.props.chapterTitle,
                conceptKey: eloDetail ? eloDetail?.conceptKey : this.props.conceptKey ? this.props.conceptKey : null,
                conceptTitle: eloDetail ? eloDetail?.conceptTitle ? eloDetail?.conceptTitle : this.props.conceptTitle : this.props.conceptTitle ? this.props.conceptTitle : null,
                eloId: eloDetail.eloId ? eloDetail.eloId : eloDetail.elos[0].id ? eloDetail.elos[0].id : null,
                eloTitle: eloDetail.title ? eloDetail.title : eloDetail ? eloDetail.elos[0].title ? eloDetail.elos[0].title : eloDetail.title : this.props.contentDisplayTitle ? this.props.contentDisplayTitle : "Chapter Introduction",
                videoContentIds: this.state.contentId,
                mobileNumbers: this.state.whatsapp,
                subType: 'USING_MOBILE_NUMBER',
                type: 'TEACHER_RESOURCE_VIDEO'
            }
        } else if (this.props.contentFrom === 'CHAPTER_INTRO') {
            payload = {
                // board: this.props.selectedBoard,
                // class: this.props.selectedClass,
                // section: this.state.sectionName,
                // boardClassSections: this.state.selectedClasses,
                // sectionId: sectionsPayload.sections,
                chapterKey: eloDetail ? eloDetail?.chapterKey ? eloDetail?.chapterKey : this.props.chapterKey : this.props.chapterKey,
                chapterTitle: eloDetail ? eloDetail?.chapterTitle ? eloDetail?.chapterTitle : this.props.chapterTitle : this.props.chapterTitle,
                conceptKey: eloDetail ? eloDetail?.conceptKey : this.props.conceptKey ? this.props.conceptKey : null,
                conceptTitle: "Chapter Introduction",
                eloId: null,
                // eloTitle: "Chapter Introduction",
                videoContentIds: this.state.contentId,
                mobileNumbers: this.state.whatsapp,
                subType: 'USING_MOBILE_NUMBER',
                type: 'TEACHER_RESOURCE_VIDEO'
            }
        } else if (this.props.contentFrom === 'VIDEO_LIBRARY') {
            payload = {
                // board: this.props.selectedBoard,
                // class: this.props.selectedClass,
                // section: this.state.sectionName,
                // boardClassSections: this.state.selectedClasses,
                // sectionId: sectionsPayload.sections,
                chapterKey: eloDetail ? eloDetail?.chapterKey ? eloDetail?.chapterKey : this.props.chapterKey : this.props.chapterKey,
                chapterTitle: eloDetail ? eloDetail?.chapterTitle ? eloDetail?.chapterTitle : this.props.chapterTitle : this.props.chapterTitle,
                conceptKey: eloDetail ? eloDetail?.conceptKey : this.props.conceptKey ? this.props.conceptKey : null,
                conceptTitle: eloDetail ? eloDetail?.conceptTitle ? eloDetail?.conceptTitle : this.props.conceptTitle : this.props.conceptTitle ? this.props.conceptTitle : null,
                eloId: null,
                // eloTitle: "Chapter Introduction",
                videoContentIds: this.state.contentId,
                mobileNumbers: this.state.whatsapp,
                subType: 'USING_MOBILE_NUMBER',
                type: 'TEACHER_RESOURCE_VIDEO'
            }
        }


        VideoSchoolAssignmentApi.createVideoSchoolAssignmentToTeacherUsingMobileNumber(payload).then(res => {
            console.log(res)

            let whatsapp = this.state.whatsapp
            whatsapp.forEach(item => {
                item.countryCode = this.userInfo.countryCode
                item.mobileNumber = ''
            })
            this.setState({ videoLink: res.data.link, whatsapp, chapterTitle: res.data.chapterTitle, conceptTitle: res.data.conceptTitle })

            // this.props.hideAssignVideoModal && this.props.hideAssignVideoModal()
            // this.props.showToaster && this.props.showToaster('info', "Video Shared Successfully to the Students")
        }).catch(err => {
            console.log(err)
        })




    }



    getCountryCodes(payload = {}) {
        CommonApi.getCountryCodeList(payload)
            .then(response => {
                let data = response.response
                if (data.length) {
                    this.setState({ countryList: data })
                    let countryCodeDropdown = this.buildCountryCodeDropdown(data)
                    this.setState({ countryCodeDropdown })
                }
            })
            .catch(err => { })
    }

    buildCountryCodeDropdown(list = []) {
        let countryCodeDropdown = []
        let localHash = {}
        for (let i = 0; i < list.length; i++) {
            let item = list[i]

            if (!localHash[item.dialCode]) {
                this.countryCodeHash[item.dialCode] = item
                localHash[item.dialCode] = item
                countryCodeDropdown.push({
                    title: `${item.name} ${item.dialCode}`,
                    addOn: item.name,
                    value: item.dialCode
                })
            }
        }
        this.setState({ hashedCountryCode: this.countryCodeHash, reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
        return countryCodeDropdown
    }

    onClickBack = () => {
        this.props.back()
    }

    onClickInfo = () => {
        this.setState({ showInfoModal: true })
    }

    hideInfoModal = () => {
        this.setState({ showInfoModal: false })
    }

    getColor(skill) {
        let colors = Constants.SKILLS_COLOR
        let color = colors[skill]
        return color
    }

    onChangeHandler = (event, key) => {
        this.setState({ [key]: event?.target?.value })
    }

    reminderNote() {
        let count = this.props.notificationCount
        let day = moment(moment()).diff(moment(this.props.notificationDate), 'days')
        if (!day) {
            return `${count} Reminders sent already today`
        }
        return `${count} Reminders sent already, Last sent ${day} days back`
    }

    onChangeEmail(event, index) {
        let emails = this.state.emails || []
        emails[index] = event.target.value
        this.setState({ emails })
    }

    onChangeWhatsapp(event, index) {
        let whatsapp = this.state.whatsapp || []
        whatsapp[index].mobileNumber = event.target.value
        this.setState({ whatsapp, whatsappVideoAssignmentType: "MOBILE_NUMBER", errorMessage: '' })
    }

    onChangeSms(event, index) {
        let sms = this.state.sms || []
        sms[index].mobileNumber = event.target.value
        this.setState({ sms })
    }

    onClickAddEmail = () => {
        let emails = this.state.emails
        emails.push("")
        this.setState({ emails })
    }

    onClickAddWhatsapp = () => {
        let whatsapp = this.state.whatsapp
        whatsapp.push({ countryCode: "+91" })
        this.setState({ whatsapp })
    }
    onClickAddSms = () => {
        let sms = this.state.sms
        sms.push({ countryCode: "+91" })
        this.setState({ sms })
    }


    onClickRemoveEmail(index) {
        let emails = this.state.emails
        if (emails.length == 1) {
            emails = [""]
        } else {
            emails.splice(index, 1)
        }
        this.setState({ emails })
    }

    onClickRemoveWhatsapp(index) {
        let whatsapp = this.state.whatsapp
        if (whatsapp.length == 1) {
            whatsapp = [{ countryCode: "+91" }]
        } else {
            whatsapp.splice(index, 1)
        }
        this.setState({ whatsapp })
    }

    onClickRemoveSms(index) {
        let sms = this.state.sms
        if (sms.length == 1) {
            sms = [{ countryCode: "+91" }]
        } else {
            sms.splice(index, 1)
        }
        this.setState({ sms })
    }


    onClickChannel(type) {
        this.setState({ type })
        this.props.onChangeType(type)
    }

    onSelectDropdown(option, index, channel) {
        let chennal = this.state[channel]
        chennal[index].countryCode = option?.value
        this.setState({ [channel]: chennal, whatsappVideoAssignmentType: "MOBILE_NUMBER", errorMessage: '' })
    }

    // shareLink = () => {

    //     let payload = this.preparePayload()


    //     console.log(payload)
    //     console.log(this.state.selectedClasses)

    //     // HomeworkApi.homeworkDeeplink(payload).then(data => {
    //     //     this.saving = false
    //     //     this.props.onOk && this.props.onOk()
    //     // }).catch(err => {
    //     //     this.saving = false
    //     // })

    // }

    createVideoSchoolAssignment = () => {

        let eloDetail = this.state.selectedEloVideoDetails

        console.log(eloDetail)

        this.setState({ errorMessage: '' })
        if (!this.state.whatsappVideoAssignmentType) {
            this.setState({ errorMessage: "Please Enter Mobile Number or Select Class & Section" })
            return;
        }


        if (this.state.whatsappVideoAssignmentType === 'MOBILE_NUMBER') {
            if (!this.validatePayloadForMobileNumber()) return false

            // let payload = {
            //     chapterKey: eloDetail ? eloDetail?.chapterKey ? eloDetail?.chapterKey : this.props.chapterKey : this.props.chapterKey,
            //     chapterTitle: eloDetail ? eloDetail?.chapterTitle ? eloDetail?.chapterTitle : this.props.chapterTitle : this.props.chapterTitle,
            //     conceptKey: eloDetail ? eloDetail?.conceptKey : this.props.conceptKey ? this.props.conceptKey : null,
            //     conceptTitle: eloDetail ? eloDetail?.conceptTitle ? eloDetail?.conceptTitle : this.props.conceptTitle : this.props.conceptTitle ? this.props.conceptTitle : null,
            //     eloId: eloDetail.eloId ? eloDetail.eloId : eloDetail.elos[0].id ? eloDetail.elos[0].id : null,
            //     eloTitle: eloDetail ? eloDetail.elos[0].title ? eloDetail.elos[0].title : eloDetail.title : this.props.contentDisplayTitle ? this.props.contentDisplayTitle : "Chapter Introduction Video",
            //     videoContentIds: this.state.contentId,
            //     mobileNumbers: this.state.whatsapp,
            //     subType: 'USING_MOBILE_NUMBER',
            //     type: 'TEACHER_RESOURCE_VIDEO'
            // }


            let payload = {
            }

            if (this.props.contentFrom === 'ELO_LIST' || this.props.contentFrom === "CHAPTER_PK") {
                payload = {
                    // board: this.props.selectedBoard,
                    // class: this.props.selectedClass,
                    // section: this.state.sectionName,
                    // boardClassSections: this.state.selectedClasses,
                    // sectionId: sectionsPayload.sections,
                    chapterKey: eloDetail ? eloDetail?.chapterKey ? eloDetail?.chapterKey : this.props.chapterKey : this.props.chapterKey,
                    chapterTitle: eloDetail ? eloDetail?.chapterTitle ? eloDetail?.chapterTitle : this.props.chapterTitle : this.props.chapterTitle,
                    conceptKey: eloDetail ? eloDetail?.conceptKey : this.props.conceptKey ? this.props.conceptKey : null,
                    conceptTitle: eloDetail ? eloDetail?.conceptTitle ? eloDetail?.conceptTitle : this.props.conceptTitle : this.props.conceptTitle ? this.props.conceptTitle : null,
                    eloId: eloDetail.eloId ? eloDetail.eloId : eloDetail.elos[0].id ? eloDetail.elos[0].id : null,
                    eloTitle: eloDetail.title ? eloDetail.title : eloDetail ? eloDetail.elos[0].title ? eloDetail.elos[0].title : eloDetail.title : this.props.contentDisplayTitle ? this.props.contentDisplayTitle : "Chapter Introduction",
                    videoContentIds: this.state.contentId,
                    mobileNumbers: this.state.whatsapp,
                    subType: 'USING_MOBILE_NUMBER',
                    type: 'TEACHER_RESOURCE_VIDEO'
                }
            } else if (this.props.contentFrom === 'CHAPTER_INTRO') {
                payload = {
                    // board: this.props.selectedBoard,
                    // class: this.props.selectedClass,
                    // section: this.state.sectionName,
                    // boardClassSections: this.state.selectedClasses,
                    // sectionId: sectionsPayload.sections,
                    chapterKey: eloDetail ? eloDetail?.chapterKey ? eloDetail?.chapterKey : this.props.chapterKey : this.props.chapterKey,
                    chapterTitle: eloDetail ? eloDetail?.chapterTitle ? eloDetail?.chapterTitle : this.props.chapterTitle : this.props.chapterTitle,
                    conceptKey: eloDetail ? eloDetail?.conceptKey : this.props.conceptKey ? this.props.conceptKey : null,
                    conceptTitle: "Chapter Introduction",
                    eloId: null,
                    // eloTitle: "Chapter Introduction",
                    videoContentIds: this.state.contentId,
                    mobileNumbers: this.state.whatsapp,
                    subType: 'USING_MOBILE_NUMBER',
                    type: 'TEACHER_RESOURCE_VIDEO'
                }
            } else if (this.props.contentFrom === 'VIDEO_LIBRARY') {
                payload = {
                    // board: this.props.selectedBoard,
                    // class: this.props.selectedClass,
                    // section: this.state.sectionName,
                    // boardClassSections: this.state.selectedClasses,
                    // sectionId: sectionsPayload.sections,
                    chapterKey: eloDetail ? eloDetail?.chapterKey ? eloDetail?.chapterKey : this.props.chapterKey : this.props.chapterKey,
                    chapterTitle: eloDetail ? eloDetail?.chapterTitle ? eloDetail?.chapterTitle : this.props.chapterTitle : this.props.chapterTitle,
                    conceptKey: eloDetail ? eloDetail?.conceptKey : this.props.conceptKey ? this.props.conceptKey : null,
                    conceptTitle: eloDetail ? eloDetail?.conceptTitle ? eloDetail?.conceptTitle : this.props.conceptTitle : this.props.conceptTitle ? this.props.conceptTitle : null,
                    eloId: null,
                    // eloTitle: "Chapter Introduction",
                    videoContentIds: this.state.contentId,
                    mobileNumbers: this.state.whatsapp,
                    subType: 'USING_MOBILE_NUMBER',
                    type: 'TEACHER_RESOURCE_VIDEO'
                }
            }


            VideoSchoolAssignmentApi.createVideoSchoolAssignmentUsingMobileNumber(payload).then(res => {
                // console.log(res)
                this.props.hideAssignVideoModal && this.props.hideAssignVideoModal()
                this.props.showToaster && this.props.showToaster('info', "Video Shared Successfully to the Students")

            }).catch(err => {
                console.log(err)
            })


        } else if (this.state.whatsappVideoAssignmentType === 'CLASS_SECTION') {
            let sectionsPayload = this.preparePayload()
            let payload = {
            }

            if (this.props.contentFrom === 'ELO_LIST' || this.props.contentFrom === "CHAPTER_PK") {
                payload = {
                    // board: this.props.selectedBoard,
                    // class: this.props.selectedClass,
                    // section: this.state.sectionName,
                    boardClassSections: this.state.selectedClasses,
                    sectionId: sectionsPayload.sections,
                    chapterKey: eloDetail ? eloDetail?.chapterKey ? eloDetail?.chapterKey : this.props.chapterKey : this.props.chapterKey,
                    chapterTitle: eloDetail ? eloDetail?.chapterTitle ? eloDetail?.chapterTitle : this.props.chapterTitle : this.props.chapterTitle,
                    conceptKey: eloDetail ? eloDetail?.conceptKey : this.props.conceptKey ? this.props.conceptKey : null,
                    conceptTitle: eloDetail ? eloDetail?.conceptTitle ? eloDetail?.conceptTitle : this.props.conceptTitle : this.props.conceptTitle ? this.props.conceptTitle : null,
                    eloId: eloDetail.eloId ? eloDetail.eloId : eloDetail.elos[0].id ? eloDetail.elos[0].id : null,
                    eloTitle: eloDetail.title ? eloDetail.title : eloDetail ? eloDetail.elos[0].title ? eloDetail.elos[0].title : eloDetail.title : this.props.contentDisplayTitle ? this.props.contentDisplayTitle : "Chapter Introduction",
                    videoContentIds: this.state.contentId,
                    subType: 'USING_CLASS_SECTION',
                    type: 'TEACHER_RESOURCE_VIDEO'
                }
            } else if (this.props.contentFrom === 'CHAPTER_INTRO') {
                payload = {
                    // board: this.props.selectedBoard,
                    // class: this.props.selectedClass,
                    // section: this.state.sectionName,
                    boardClassSections: this.state.selectedClasses,
                    sectionId: sectionsPayload.sections,
                    chapterKey: eloDetail ? eloDetail?.chapterKey ? eloDetail?.chapterKey : this.props.chapterKey : this.props.chapterKey,
                    chapterTitle: eloDetail ? eloDetail?.chapterTitle ? eloDetail?.chapterTitle : this.props.chapterTitle : this.props.chapterTitle,
                    conceptKey: eloDetail ? eloDetail?.conceptKey : this.props.conceptKey ? this.props.conceptKey : null,
                    conceptTitle: "Chapter Introduction",
                    eloId: null,
                    // eloTitle: "Chapter Introduction",
                    videoContentIds: this.state.contentId,
                    subType: 'USING_CLASS_SECTION',
                    type: 'TEACHER_RESOURCE_VIDEO'
                }
            } else if (this.props.contentFrom === 'VIDEO_LIBRARY') {
                payload = {
                    // board: this.props.selectedBoard,
                    // class: this.props.selectedClass,
                    // section: this.state.sectionName,
                    boardClassSections: this.state.selectedClasses,
                    sectionId: sectionsPayload.sections,
                    chapterKey: eloDetail ? eloDetail?.chapterKey ? eloDetail?.chapterKey : this.props.chapterKey : this.props.chapterKey,
                    chapterTitle: eloDetail ? eloDetail?.chapterTitle ? eloDetail?.chapterTitle : this.props.chapterTitle : this.props.chapterTitle,
                    conceptKey: eloDetail ? eloDetail?.conceptKey : this.props.conceptKey ? this.props.conceptKey : null,
                    conceptTitle: eloDetail ? eloDetail?.conceptTitle ? eloDetail?.conceptTitle : this.props.conceptTitle : this.props.conceptTitle ? this.props.conceptTitle : null,
                    eloId: null,
                    // eloTitle: "Chapter Introduction",
                    videoContentIds: this.state.contentId,
                    subType: 'USING_CLASS_SECTION',
                    type: 'TEACHER_RESOURCE_VIDEO'
                }
            }




            if (!this.validatePayload(payload)) return

            VideoSchoolAssignmentApi.createVideoSchoolAssignment(payload).then(res => {
                // console.log(res)
                this.props.hideAssignVideoModal && this.props.hideAssignVideoModal()
                this.props.showToaster && this.props.showToaster('info', "Video Shared Successfully to the Students")

            }).catch(err => {
                console.log(err)
            })
        }
    }

    validatePayloadForMobileNumber() {

        if (this.state.type == "WHATSAPP") {
            let whatsapp = this.state.whatsapp
            let invalidWhatsapp = {}
            for (let i = 0; i < whatsapp.length; i++) {

                if (!whatsapp[i].countryCode) {
                    invalidWhatsapp[i] = "Please Select the Country Code"
                    continue
                }

                let countryCodeDetail = this.countryCodeHash[whatsapp[i].countryCode]
                if (!Utils.validateMobileNumber(whatsapp[i].mobileNumber, countryCodeDetail)) {
                    invalidWhatsapp[i] = "Please Enter Mobile Number"
                }
            }

            this.setState({ invalidWhatsapp })
            return !Object.keys(invalidWhatsapp).length
        }
        return false
    }

    onClickCopy = () => {
        let textField = document.createElement('textarea')
        textField.innerText = `${this.notificationText} ${this.notificationLink}?schoolCode=${this.userInfo?.schoolInfo?.schoolCode}`
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove()
        this.showTooltip()
    }

    showTooltip() {
        this.setState({ tooltipOpen: true })
        setTimeout(() => {
            this.setState({ tooltipOpen: false })
        }, 1000)
    }

    onSelectClass = (option, index) => {
        const { selectedClasses } = this.state
        selectedClasses[index].class = option?.value
        this.setState({ selectedClasses, whatsappVideoAssignmentType: 'CLASS_SECTION' }, _ => {
            this.getSections({ board: selectedClasses[index].board, class: option?.value }, index)
            this.localValidation()
        })
    }

    onSelectBoard = (option, index) => {
        const { selectedClasses } = this.state
        selectedClasses[index].board = option?.value
        this.setState({ selectedClasses }, _ => {
            if (selectedClasses[index].class) this.getSections({ board: option?.value, class: selectedClasses[index].class }, index)
            this.localValidation()
        })
    }

    onSelectSection = (options, index) => {
        const { selectedClasses } = this.state
        selectedClasses[index].sections = options.map(opt => opt.value)
        this.setState({ selectedClasses }, _ => {
            if (this.dropdown[index]) this.dropdown[index].toggleExpandView()
            this.localValidation()
        })
    }

    getSections(payload = {}, index = 0, isEdit) {
        const { boards } = this.props
        const { selectedClasses } = this.state
        if (!payload.class) payload.class = this.state.selectedClass
        if (!payload.board) payload.board = boards[0].title
        SchoolApi.getSections(payload)
            .then(response => {
                const { sections } = this.state
                sections[index] = []
                for (let i = 0; i < response.response.length; i++) {
                    sections[index].push({
                        title: response.response[i].section,
                        value: response.response[i]._id,
                    })
                }

                this.setState({ sections }, _ => {
                    if (this.dropdown[index]) {
                        if (isEdit && payload.board && payload.class) {
                            const filteredClass = selectedClasses.filter(sc => sc.class === payload.class && sc.board === payload.board)
                            console.log(filteredClass)
                            if (filteredClass.length > 0 && filteredClass[0].sections?.length > 0) {
                                filteredClass[0].sections.map(fc => {
                                    const idx = sections[index].findIndex(s => s.value === fc)
                                    console.log(idx)
                                    if (idx > -1) {
                                        this.dropdown[index].onClickOption(sections[index][idx])
                                    }
                                })
                            }
                        }
                        this.dropdown[index].resetMulitSelectDropdown()
                    }
                })
            }).catch(err => {
            })
    }

    preparePayload() {
        return { sections: this.prepareSections() }
    }

    prepareSections = _ => {
        const { selectedClasses } = this.state
        const sections = []
        selectedClasses.map(sc => {
            sc.sections.map(s => sections.push(s))
        })
        return sections
    }

    validatePayload(payload = {}, dontShowErrorMessage) {

        if ((!payload.sectionId || !payload.sectionId.length)) {
            if (!dontShowErrorMessage) this.setState({ errorMessage: "Please select class & section" })
            return false
        }

        return true
    }

    localValidation() {
        let payload = this.preparePayload()
        let validate = this.validatePayload(payload, true)
        console.log(validate)
        this.setState({ validation: validate, errorMessage: "" })
    }

    addNewClass = _ => {
        const { selectedClasses } = this.state
        selectedClasses.push({ class: "", sections: [] })
        this.setState({ selectedClasses })
    }

    removeClass = index => {
        const { selectedClasses } = this.state
        selectedClasses.splice(index, 1)
        this.setState({ selectedClasses })
    }

    copyLink = _ => {
        const { homeworkAssigedDetails } = this.state
        var dummy = document.createElement('textarea')
        // dummy.style.display = 'none'
        document.body.appendChild(dummy)

        //         dummy.value = `Hello,

        // You have been given a new assignment. Complete this video lesson to understand the real-life Applications of ${this.state.chapterTitle}. 

        // Through this video, you will understand the following concept: ${this.state.conceptTitle}.

        // Tap/Click this link to start your video lesson : ${this.state.videoLink}

        // All the best,
        // Countingwell`

        dummy.value = `${this.state.videoLink}`
        dummy.select()
        document.execCommand('copy')
        document.body.removeChild(dummy)
        this.showToaster('info', 'Copied')
    }

    showToaster(type, message) {
        this.setState(
            {
                showToaster: true,
                toasterMessage: message,
                toasterType: type
            },
            () => {
                setTimeout(() => {
                    this.hideToaster()
                }, 3000)
            }
        )
    }

    hideToaster() {
        this.setState({
            showToaster: false
        })
    }


    render() {

        const { selectedClasses, classes, sections, boards, board } = this.state


        return (
            <div className='assessment-notification'>
                {
                    this.state.videoLink ?

                        <div className='homework-success-left-content'>
                            <div className='title'>
                                Copy this link and share with students
                            </div>
                            <div className='share-link cursor-pointer' title="Copy Link" onClick={this.copyLink}>
                                {this.state.videoLink}
                            </div>
                        </div>
                        :
                        <></>
                }

                <div className="text-center pt-4">
                    <span className="share cursor-pointer" onClick={this.copyLink}>Copy Link</span>
                </div>



                <div className='share-container mt-2 my-2'>
                    {/* <div className='share-left'>
                        <div className='step'>2</div>
                    </div> */}
                    <div className='share-right'>
                        <div className='title'>Share with a Number</div>
                        {/* <div className='description'>
                            Send to yourself by entering
                            your {this.state.type == "EMAIL" ? "Email" : "number"} and forward it to other users from your
                            own {this.state.type == "EMAIL" ? "Email" : "Whatsapp number"}.
                        </div> */}
                    </div>
                </div>

                <div className="message-wrapper">
                    {
                        this.state.type == "WHATSAPP" ?
                            <div>
                                <div className="row mt-2">
                                    <div className="col px-0 my-auto">
                                        {
                                            this.state.whatsapp?.map((item, index) =>
                                                <div className={`mt-2 `}>
                                                    <div className={`row mobilenumber-wrapper px-0 ${this.state.invalidWhatsapp[index] ? "invalid" : ""}`}>
                                                        <div className="col-4 px-0">
                                                            {
                                                                !this.state.reloadDropdown ?
                                                                    <Dropdown
                                                                        placeholder='Select'
                                                                        options={this.state.countryCodeDropdown}
                                                                        onSelect={(option) => this.onSelectDropdown(option, index, "whatsapp")}
                                                                        text={"title"}
                                                                        value={item?.countryCode || ""}
                                                                        style={{ backgroundColor: "#F6F7F5" }}
                                                                    />
                                                                    : ""
                                                            }
                                                        </div>
                                                        <div className="col-8 px-0">
                                                            <input className="cw-input" placeholder="Please Enter Mobile" value={item.mobileNumber} onChange={event => this.onChangeWhatsapp(event, index)} />
                                                            <img className="delete icon-20 mt-2 ml-2 cursor-pointer" onClick={() => this.onClickRemoveWhatsapp(index)} src={getImageSource(ImageConstants.DELETE_RED)} />
                                                        </div>
                                                    </div>

                                                </div>
                                            )
                                        }
                                    </div>
                                </div>

                            </div> : ""
                    }



                    {/* <div className="text-center pt-4">
                        <span className="note mr-2">Share link via other channels:</span>
                        {this.state.type != "EMAIL" ? <img className="icon-20 mr-2 cursor-pointer" onClick={() => this.onClickChannel("EMAIL")} src={getImageSource(ImageConstants.EMAIL)} /> : ""}
                        {this.state.type != "WHATSAPP" ? <img className="icon-20 mr-2 cursor-pointer" onClick={() => this.onClickChannel("WHATSAPP")} src={getImageSource(ImageConstants.WHATSAPP)} /> : ""}
                    </div> */}
                </div>
                <div className="text-right text-primary add pt-2">
                    <span className="cursor-pointer" onClick={this.onClickAddWhatsapp}>+ ADD WHATSAPP NO.</span>
                </div>
                <div className='separator'>
                    <img src={getImageSource(ImageConstants.SEPARATOR)} />
                    <span className='separator-text'>OR</span>
                </div>

                <div>
                    <div className='row bw-spaces-input'>
                        <div className='col-12 cw-label-container'>
                            <label className='cw-input-label no-padding'>
                                Share with a Class
                            </label>
                        </div>
                    </div>
                    {selectedClasses.map((c, index) =>
                        <>
                            <div className='row mt-1 grouped-dropdown-container' key={index} onMouseEnter={ReactTooltip.rebuild}>
                                {boards?.length > 1 && (
                                    <div className='col-3 pr-0 grouped-dropdown first'>
                                        <Dropdown
                                            placeholder='Board'
                                            options={boards}
                                            onSelect={option => this.onSelectBoard(option, index)}
                                            text='title'
                                            style={{ background: '#F6F7F5' }}
                                            value={c.board}
                                        />
                                        <div className='divider'></div>
                                    </div>
                                )}
                                <div className={`${boards?.length > 1 ? 'col-3' : 'col-4'} pl-0 pr-0 grouped-dropdown`}>
                                    {this.state.classes?.length && (
                                        <Dropdown
                                            placeholder='Class'
                                            options={classes}
                                            onSelect={option => this.onSelectClass(option, index)}
                                            text='title'
                                            style={{ background: '#F6F7F5' }}
                                            value={c.class}
                                        />
                                    )}
                                    <div className='divider'></div>
                                </div>
                                <div className={`${boards?.length > 1 ? 'col-6' : 'col-8'} pl-0 pr-0 grouped-dropdown last`}>
                                    <Dropdown
                                        ref={el => this.dropdown[index] = el}
                                        placeholder='Sections'
                                        options={this.state.sections[index]}
                                        onSelect={options => this.onSelectSection(options, index)}
                                        text='title'
                                        style={{ background: '#F6F7F5' }}
                                        value={c.sections}
                                        multiSelect={true}
                                        hideAllDelete={true}
                                    />
                                </div>
                                <div className='remove-class'>
                                    {/* {((c.class && c.board) || (c.class && boards.length === 1)) &&
                                        <div className='cursor-pointer mr-1' data-tip={"Add New Section"} onClick={_ => this.showAddSection(c.class, index)}>
                                            <img
                                                src={getImageSource(ImageConstants.ADD)}
                                                className='add-remove-icon'
                                            ></img>
                                        </div>
                                    } */}
                                    {index > 0 &&
                                        <div className='remove-class cursor-pointer' onClick={_ => this.removeClass(index)}>
                                            <img
                                                src={getImageSource(ImageConstants.DELETE_RED)}
                                                className='close-icon'
                                            ></img>
                                        </div>
                                    }
                                </div>
                            </div>
                        </>
                    )}
                    <div className='text-right'>
                        <span className='add-new-class' onClick={this.addNewClass}>+ ADD CLASS</span>
                    </div>
                </div>
                <div className="text-center pt-4">
                    {this.state.errorMessage ? <div className="text-danger pb-4"><strong>{this.state.errorMessage} </strong></div> : ""}
                    <span className="share cursor-pointer" onClick={this.createVideoSchoolAssignment}>Share Link</span>
                </div>
                {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}
            </div >
        );
    }
}

export default Reminder;